import { getFullUrl } from 'hubspot-url-utils';
function getShareableFormUrl() {
  return getFullUrl('share', {
    domainOverride: 'hsforms',
    tldOverride: 'com'
  });
}
export default getShareableFormUrl;